import config from "../config";
import type { APIConfigType } from "./types";

const { baseApiURL } = config;

const profileBaseUrl = `${baseApiURL}v1/user/`;
const profileClientBaseUrl = "/api/profile/";

const API_CONFIG = {
  trackUser: {
    back: `${profileBaseUrl}track-visitor`,
  },
  login: {
    client: `${profileClientBaseUrl}auth/login`,
    back: `${profileBaseUrl}login`,
  },
  loginWithPassword: {
    client: `${profileClientBaseUrl}auth/login-with-password`,
    back: `${profileBaseUrl}login-with-password`,
  },
  confirm: {
    client: `${profileClientBaseUrl}auth/confirm`,
    back: `${profileBaseUrl}confirm`,
  },
  orderPDF: {
    client: `${profileClientBaseUrl}orderPDF`,
    back: "pdf",
  },
  profile: `${profileBaseUrl}profile`,
  updateProfile: {
    client: `${profileClientBaseUrl}update`,
    back: `${profileBaseUrl}profile`,
  },
  orders: {
    back: `${profileBaseUrl}orders`,
  },
  orderDetail: {
    back: `${profileBaseUrl}orders`,
  },
  transactions: {
    back: `${profileBaseUrl}transactions`,
  },
  chargeBalance: {
    client: `${profileClientBaseUrl}chargeBalance`,
    back: `${profileBaseUrl}charge-balance`,
  },
  status: {
    client: `${profileClientBaseUrl}status`,
    back: `${profileBaseUrl}orders`,
  },
};

export const PROFILE_API_CONFIG: APIConfigType<typeof API_CONFIG> = API_CONFIG;
